import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

import Image from './c/Image/Image'

const breakpoints = [440, 768, 1024, 1200, 1400];
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`));

const wrapMQ = css(mq({
  gap: [
    24, // 0+
    24, // 440+
    24, // 768+
    24, // 1024+
    32, // 1200+
    60, // 1400+
  ],
  gridTemplateColumns: [
    "1fr", // 0+
    "1fr", // 440+
    "1fr", // 768+
    "265px 1fr", // 1024+
    "340px 1fr", // 1200+
    "340px 1fr", // 1400+
  ],
}))

export const Wrap = styled.div`
  display: grid;
  grid-template-columns: 340px 1fr;
  ${wrapMQ}
`

const listWrapMQ = css(mq({
  marginLeft: [
    0, // 0+
    0, // 440+
    0, // 768+
    0, // 1024+
    0, // 1200+
    -64, // 1400+
  ],
}))

export const ListWrap = styled.div`
  position: relative;
  display: flex;
  align-items: start;
  gap: 56px;
  ${listWrapMQ}
`

const tocMQ = css(mq({
  display: [
    "none", // 0+
    "none", // 440+
    "none", // 768+
    "none", // 1024+
    "none", // 1200+
    "flex", // 1400+
  ],
}))

export const Toc = styled.div`
  position: sticky;
  top: 112px;
  flex-direction: column;
  align-items: end;
  margin-top: 6px;
  width: 8px;
  gap: 12px;
  ${tocMQ}
`

const activeTocItem = ({ isActive }) => {
  if (isActive) {
    return css({
      background: "var(--color-white)",
      width: 8,
    })
  }
}

export const TocItem = styled.div`
  width: 6px;
  height: 3px;
  border-radius: 3px;
  background: var(--color-grayscale-700);
  transition: background, width var(--transition);
  ${activeTocItem}
`

const listMQ = css(mq({
  width: [
    "100%", // 0+
    "100%", // 440+
    "100%", // 768+
    "auto", // 1024+
    "auto", // 1200+
    "auto", // 1400+
  ],
  gap: [
    0, // 0+
    0, // 440+
    0, // 768+
    12, // 1024+
    12, // 1200+
    12, // 1400+
  ],
}))

export const List = styled.div`
  display: flex;
  flex-direction: column;
  ${listMQ}
`

const itemMQ = css(mq({
  position: [
    "sticky", // 0+
    "sticky", // 440+
    "sticky", // 768+
    "static", // 1024+
  ],
  top: [
    64, // 0+
    64, // 440+
    64, // 768+
    "unset", // 1024+
  ],
  paddingTop: [
    32, // 0+
    32, // 440+
    32, // 768+
    0, // 1024+
    0, // 1200+
    0, // 1400+
  ],
}))

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: var(--color-grayscale-900);
  ${itemMQ}
`

const buttonMQ = css(mq({
  font: [
    "var(--accent-670)", // 0+
    "var(--accent-670)", // 440+
    "var(--accent-770)", // 768+
    "var(--accent-470)", // 1024+
    "var(--accent-470)", // 1200+
    "var(--accent-470)", // 1400+
  ],
}))

const activeButton = ({ isActive }) => {
  if (isActive) {
    return css(mq({
      color: [
        "var(--color-grayscale-600)", // 0+
        "var(--color-grayscale-600)", // 440+
        "var(--color-grayscale-600)", // 768+
        "var(--color-white)", // 1024+
        "var(--color-white)", // 1200+
        "var(--color-white)", // 1400+
      ],
      font: [
        "var(--accent-670)", // 0+
        "var(--accent-670)", // 440+
        "var(--accent-770)", // 768+
        "var(--accent-470)", // 1024+
        "var(--accent-670)", // 1200+
        "var(--accent-670)", // 1400+
      ],
    }))
  }
}

export const Button = styled.button`
  display: flex;
  align-items: center;
  height: 32px;
  text-align: left;
  color: var(--color-grayscale-600);
  ${buttonMQ}
  ${activeButton}
`

const innerImageMQ = css(mq({
  display: [
    "flex", // 0+
    "flex", // 440+
    "flex", // 768+
    "none", // 1024+
  ],
}))

export const InnerImage = styled(Image)`
  ${innerImageMQ}
`

const imageWrapMQ = css(mq({
  display: [
    "none", // 0+
    "none", // 440+
    "none", // 768+
    "flex", // 1024+
  ],
}))

export const ImageWrap = styled.div`
  display: flex;
  justify-content: end;
  ${imageWrapMQ}
`

export const ImageBg = styled.div`
  position: sticky;
  top: 112px;
  display: flex;
  width: 100%;
  max-width: 860px;
  border-radius: 16px;
  background: linear-gradient(266deg, #FA635A 7.5%, #F96674 37.58%);
  height: 540px;
`
